import { Select } from 'antd';
import useSmartField from 'hooks/useSmartField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';

function RepurchasePeriodDays() {
  const { t } = useTranslate();

  const {
    field: { value, onChange },
  } = useSmartField<FV['repurchasePeriodDays']>('repurchasePeriodDays');

  return (
    <Select
      dropdownMatchSelectWidth={false}
      value={value}
      onChange={onChange}
      options={[
        { value: 7, label: t('一周') },
        { value: 30, label: t('market.一个月') },
        { value: 90, label: t('三个月') },
      ]}
    />
  );
}

export default RepurchasePeriodDays;
